export default {
  districts: []
}
